import { render, staticRenderFns } from "./ReportAdminUserDetail.vue?vue&type=template&id=050150a2&scoped=true"
import script from "./ReportAdminUserDetail.vue?vue&type=script&lang=js"
export * from "./ReportAdminUserDetail.vue?vue&type=script&lang=js"
import style0 from "./ReportAdminUserDetail.vue?vue&type=style&index=0&id=050150a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050150a2",
  null
  
)

export default component.exports